import React from 'react';
import { AlertTriangle, X } from 'lucide-react';

type ConfirmDeleteModalProps = {
  isOpen: boolean;
  consultant: any;
  onClose: () => void;
  onConfirm: () => void;
};

export const ConfirmDeleteModal = ({
  isOpen,
  consultant,
  onClose,
  onConfirm,
}: ConfirmDeleteModalProps) => {
  if (!isOpen || !consultant) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full overflow-hidden">
        {/* Header */}
        <div className="px-6 py-4 bg-gradient-to-r from-red-600 to-red-700 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <AlertTriangle className="w-6 h-6 text-white" />
            <h3 className="text-lg font-semibold text-white">Confirmar Exclusão</h3>
          </div>
          <button
            onClick={onClose}
            className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6">
          <p className="text-gray-600">
            Tem certeza que deseja excluir o consultor <span className="font-semibold">{consultant.consultant}</span>?
            Esta ação não pode ser desfeita.
          </p>

          <div className="mt-6 flex justify-end gap-3">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
            >
              Confirmar Exclusão
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};